import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BasicService } from 'src/app/shared/services/basic.service';
import { TransformationEditionComponent } from './transformation-edition/transformation-edition.component';

@Component({
  selector: 'app-links-subconfig',
  templateUrl: './links-subconfig.component.html',
  styleUrls: ['./links-subconfig.component.scss'],
})
export class LinksSubconfigComponent {
  @Input() data: any;
  @Output() subConfigChanged: EventEmitter<void> = new EventEmitter();

  constructor(private basicService: BasicService, private dialog: MatDialog) {}

  addTransformation() {
    this.data.transformations.push({
      hostname: this.basicService.translate('account/links/transformations/example-hostname'),
      actions: [],
    });
    this.subConfigChanged.emit();
    this.editTransformation(this.data.transformations.length - 1);
  }

  deleteTransformation(index) {
    this.data.transformations.splice(index, 1);
    this.subConfigChanged.emit();
  }

  editTransformation(index) {
    const dialogRef = this.dialog.open(TransformationEditionComponent, {
      panelClass: ['transformation-edition'],
      autoFocus: false,
      data: {
        transformation: { ...this.data.transformations[index] },
        tagLabelPerTaskTagId: this.data.tagLabelPerTaskTagId,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subConfigChanged.emit();
        this.data.transformations[index].hostname = result.transformation.hostname;
        this.data.transformations[index].actions = result.transformation.actions;
        this.data.transformations[index].is_encrypted = result.transformation.is_encrypted;
      }
    });
  }

  addException() {
    this.data.exceptions.push({
      url: 'http://exception.com/to/url',
    });
    this.subConfigChanged.emit();
  }

  deleteException(index) {
    this.data.exceptions.splice(index, 1);
    this.subConfigChanged.emit();
  }
}
